<template>
    <v-app v-resize="onResize">
        <s-nav-bar :drawer.sync="drawer"/>
        <s-nav-drawer :drawer.sync="drawer"/>

        <v-main class="neutral-1">
            <system-feedback/>

            <v-container :class="[!drawer ? 'px-0' : 'px-3']">

                <s-breadcrumb
                    :class="['mb-2', $vuetify.breakpoint.smAndDown ? 'px-4' : 'px-0']"
                    :items="breadcrumb"
                />

                <template v-if="pageTitle || $slots['page-title']">
                    <div
                        v-if="pageTitle"
                        :class="['t-heading-large mb-3', $vuetify.breakpoint.smAndDown ? 'px-4' : 'px-0']"
                        v-text="pageTitle"
                    ></div>
                    <div v-else><slot name="page-title"></slot></div>
                </template>

                <div v-if="$slots['actions-top'] || $slots['search-top']" class="a4-paper pa-4 mb-3 d-flex justify-space-between">
                    <v-row>
                        <v-col align-self="center">
                            <slot name="actions-top"></slot>
                        </v-col>
                        <v-col md="4" align-self="center">
                            <slot name="search-top"></slot>
                        </v-col>
                    </v-row>
                </div>

                <div class="a4-paper pa-4">

                    <template v-if="categoryTitle || $slots['category-title']">
                        <div
                            v-if="categoryTitle"
                            class="t-heading-medium-lg"
                            v-text="categoryTitle"
                        ></div>
                        <div v-else><slot name="category-title"></slot></div>
                    </template>

                    <template v-if="categorySubtitle || $slots['category-subtitle']">
                        <div
                            v-if="categorySubtitle"
                            class="t-subtitle mt-2"
                            v-text="categorySubtitle"
                        ></div>
                        <div v-else><slot name="category-subtitle"></slot></div>
                    </template>

                    <slot name="filters-top"></slot>

                    <v-divider
                        v-if="categoryDivider"
                        class="my-2"
                    ></v-divider>

                    <slot/>

                </div>

                <div v-if="formAction || $slots['form-action']" class="form-action d-flex justify-end pa-4">
                    <slot name="form-action"></slot>
                </div>

            </v-container>
        </v-main>

        <password-confirm ref="password_confirm"/>
        <simple-modal ref="simple_modal"/>
        <simple-feedback ref="simple_feedback"/>

        <s-footer ref="footer"/>
    </v-app>
</template>

<script>
import PasswordConfirm from '../modal/PasswordConfirm';
import {default as SNavBar} from './structure/NavBar';
import {default as SNavDrawer} from './structure/NavDrawer';
import {default as SFooter} from './structure/Footer';
import {default as SBreadcrumb} from './structure/Breadcrumb';
import SimpleModal from './support/SimpleModal';
import SimpleLoading from './support/SimpleLoading';
import SystemFeedback from './support/SystemFeedback';
import SimpleFeedback from './support/SimpleFeedback';

export default {
    components: {
        PasswordConfirm,
        SNavBar,
        SNavDrawer,
        SFooter,
        SBreadcrumb,
        SimpleModal,
        SystemFeedback,
        SimpleFeedback,
    },
    props: {
        breadcrumb: {
            type: Array,
            required: false,
            default: () => [],
        },
        pageTitle: {
            type: String,
            required: false,
            default: null,
        },
        categoryTitle: {
            type: String,
            required: false,
            default: null,
        },
        categorySubtitle: {
            type: String,
            required: false,
            default: null,
        },
        formAction: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data: (vm) => ({
        drawer: true,
        loading: false,
        onResize: _.debounce(() => {
            vm.mainStyle = { 'padding-bottom': `${vm.$refs.footer.$el.clientHeight}px !important` };
        }, 500),
    }),
    created () {
        this.$bus.$on('simple-modal', (config = {}, loading = false) => {
            this.loading = loading;

            this.$nextTick(() => {
                this.$refs.simple_modal.open(config);
            });
        });
        this.$bus.$on('password-confirm', (config = {}, loading = false) => {
            this.loading = loading;

            this.$nextTick(() => {
                this.$refs.password_confirm.open(config);
            });
        });

        this.$bus.$on('on-loading', () => {
            this.$bus.$emit('simple-modal', {
                size: 'small',
                persistent: true,
                noFullscreen: true,
                component: SimpleLoading,
                noAction: true,
            }, true);
        });

        this.$bus.$on('off-loading', () => {
            if (!this.loading) return;

            this.loading = false;
            this.$refs.simple_modal.close();
        });

        this.$bus.$on('feedback', (config = {}) => {
            this.$refs.simple_feedback.show(config);
        });
    },
    beforeDestroy () {
        this.$bus.$off('simple-modal');
        this.$bus.$off('on-loading');
        this.$bus.$off('off-loading');
        this.$bus.$off('feedback');
    },
    computed: {
        categoryDivider() {
            return this.categoryTitle || this.categorySubtitle ||
            this.$slots['category-title'] || this.$slots['category-subtitle'];
        },
    },
}
</script>

<style scoped lang="scss">
$paper-color: var(--v-white-base);
$paper-border: 1px solid var(--v-neutral-2-base);

.a4-paper {
    background-color: $paper-color;
    border: $paper-border;
}

.form-action {
  background-color: var(--v-neutral-1-base) !important;
  border: 1px solid var(--v-neutral-2-base) !important;
  border-top: none;
}

@media (max-width: 959px) {
    .a4-paper {
        border-top: $paper-border;
        border-bottom: $paper-border;
        border-left: none;
        border-right: none;
    }
}
</style>
